// import LocalActionItemProvider from './LocalActionItemProvider';
import { memo } from 'react';
import { useMount } from 'react-use';

import { cn } from '@lyearn/style';
import { Box, Stack } from '@lyearn/ui';

import { TASK_LIST_SIZE_CONFIG } from '../consts';
import StatusLoader from '../hooks/useGroupedTable/StatusLoader';
import TitleLoader from '../hooks/useGroupedTable/TitleLoader';
import { GroupedListProps } from '../types';

function SubtaskListing({
  className,
  parentId,
  onFetchChildActionItems,
}: Pick<GroupedListProps, 'setInViewTask' | 'actions' | 'providers'> & {
  className?: string;
  parentId: string;
  cells: React.ReactNode;
  sizeConfig: (typeof TASK_LIST_SIZE_CONFIG)[keyof typeof TASK_LIST_SIZE_CONFIG];
  onFetchChildActionItems: (parentId: string) => void;
}) {
  useMount(() => {
    onFetchChildActionItems(parentId);
  });

  return (
    <Stack alignItems="center" className={cn('w-full', className)} gap={16}>
      <Box className="BaseTable__row-cell">
        <StatusLoader />
      </Box>
      <TitleLoader />
    </Stack>
  );
}

export default memo(SubtaskListing);
